import React, { useState, useEffect } from 'react'
import axios from 'axios'

const API_URL = 'https://jupiter.grub.digital/'

const styles = {
  container: {
    background: '#fff',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '16px'
  },
  tierBadge: (color) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '4px 12px',
    borderRadius: '20px',
    backgroundColor: color ? `${color}20` : '#f3f4f6',
    color: color || '#6b7280',
    fontSize: '0.8rem',
    fontWeight: 600
  }),
  pointsValue: {
    fontSize: '2rem',
    fontWeight: 700,
    color: '#111827',
    lineHeight: 1.2
  },
  pointsLabel: {
    fontSize: '0.8rem',
    color: '#6b7280',
    marginTop: '2px'
  },
  progressContainer: {
    marginTop: '16px'
  },
  progressBar: {
    width: '100%',
    height: '8px',
    backgroundColor: '#e5e7eb',
    borderRadius: '4px',
    overflow: 'hidden'
  },
  progressFill: (percentage, color) => ({
    width: `${Math.min(percentage, 100)}%`,
    height: '100%',
    backgroundColor: color || '#006aff',
    borderRadius: '4px',
    transition: 'width 0.3s ease'
  }),
  progressText: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '6px',
    fontSize: '0.75rem',
    color: '#6b7280'
  },
  link: {
    display: 'block',
    marginTop: '16px',
    textAlign: 'center',
    color: '#006aff',
    fontSize: '0.85rem',
    fontWeight: 600,
    textDecoration: 'none',
    cursor: 'pointer'
  }
}

function LoyaltyWidget({ brand, token, onNavigate }) {
  const [saldo, setSaldo] = useState(null)
  const [loading, setLoading] = useState(true)
  const [hidden, setHidden] = useState(false)

  useEffect(() => {
    if (!brand || !token) {
      setHidden(true)
      setLoading(false)
      return
    }
    fetchSaldo()
  }, [brand, token])

  const fetchSaldo = async () => {
    try {
      const response = await axios.get(`${API_URL}public/fidelidade/saldo/${brand}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      if (response.data && response.data.success) {
        setSaldo(response.data.data)
      } else {
        setHidden(true)
      }
    } catch (error) {
      // 404 means no active loyalty program
      if (error.response && error.response.status === 404) {
        setHidden(true)
      } else {
        setHidden(true)
      }
    } finally {
      setLoading(false)
    }
  }

  if (loading || hidden || !saldo) return null

  const { pontos_disponiveis, nivel, proximo_nivel } = saldo
  const tierColor = nivel?.cor || '#006aff'
  const tierName = nivel?.nome || 'Membro'

  // Calculate progress to next tier
  let progressPercentage = 100
  let pointsRemaining = 0
  if (proximo_nivel) {
    const currentMin = nivel?.pontos_minimos || 0
    const nextMin = proximo_nivel.pontos_minimos
    const totalAccumulated = saldo.pontos_acumulados_total || 0
    const range = nextMin - currentMin
    const progress = totalAccumulated - currentMin
    progressPercentage = range > 0 ? Math.floor((progress / range) * 100) : 0
    pointsRemaining = Math.max(0, nextMin - totalAccumulated)
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <div style={styles.pointsValue}>{pontos_disponiveis?.toLocaleString('pt-BR') || 0}</div>
          <div style={styles.pointsLabel}>pontos disponíveis</div>
        </div>
        <div style={styles.tierBadge(tierColor)}>
          {nivel?.icone_url && (
            <img src={nivel.icone_url} alt="" style={{ width: 16, height: 16 }} />
          )}
          {tierName}
        </div>
      </div>

      {proximo_nivel && (
        <div style={styles.progressContainer}>
          <div style={styles.progressBar}>
            <div style={styles.progressFill(progressPercentage, tierColor)} />
          </div>
          <div style={styles.progressText}>
            <span>{progressPercentage}% para {proximo_nivel.nome}</span>
            <span>{pointsRemaining.toLocaleString('pt-BR')} pts restantes</span>
          </div>
        </div>
      )}

      {onNavigate && (
        <div style={styles.link} onClick={() => onNavigate('beneficios')}>
          Ver benefícios disponíveis →
        </div>
      )}
    </div>
  )
}

export default LoyaltyWidget
